import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature, hasFeatureValue} from '../../../util/values';
import {selectSpcAttributes, selectSpcConfiguration} from '../../../selectors';

@customElement('svg-model')
export class SvgModel extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
	  }

	  svg {
		height: 100%;
		width: auto;
		margin: auto;
	  }

	  .model {
		transform-origin: center;
		filter: blur(10px) brightness(1);
		transform: scale(0.95);
		opacity: 90%;
		transition: opacity 0.4s, filter 0.4s, transform 0.4s;
	  }

	  .selected {
		transform: scale(1);
		filter: blur(0px) brightness(1.3);
		opacity: 100%
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.status = state.status;
	}

	getModelGroup(model) {
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-model.svg';
		return svg`
			<use
				href="${svgPath}#${model}"
				class="model ${classMap({selected: hasFeatureValue('HS_HousingType', model, this.spcConfiguration)})}">
			</use>
		`;
	}
	render() {
		const s = this.state;
		const svgPath = 'visuals/line-model.svg';
		return svg`
			<svg width="2050px" height="2000px" viewBox="0 0 2050 2000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<title>line-model</title>
				<g id="line-model" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="selection" transform="translate(0.000000, 750.000000)" stroke="#939393">
						<use href="${svgPath}#selection-${getValueOfFeature('HS_HousingType', this.spcConfiguration)}"></use>
					</g>
					<g id="models" transform="translate(228.000000, 113.000000)">
						${this.getModelGroup('Bollard')}
						${this.getModelGroup('WallSurface')}
						${this.getModelGroup('WallRecessed')}
						${this.getModelGroup('PoleLateral')}
						${this.getModelGroup('PoleTop')}
						${this.getModelGroup('Column')}
						${this.getModelGroup('ColumnTwist12')}
						${this.getModelGroup('ColumnTwist06')}
					</g>
				</g>
			</svg>
		`;
	}
}
